import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { ListRegionTypeCardFragment } from "../../client/generated";
import { RegionTypeCard } from "../RegionTypeCard";
import { useTranslation } from "react-i18next";

type Props = {
  fragment: ListRegionTypeCardFragment;
  dispatch: Dispatch<EditorAction>;
};

export function ListRegionTypeCard({ fragment, dispatch }: Props) {
  const { t } = useTranslation();

  const onConvert = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "list",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTypeCard
      title={t("ListRegionTypeCard.title")}
      description={t("ListRegionTypeCard.description")}
      onConvert={onConvert}
    />
  );
}
